import firebaseStore from 'firebase/app'
import 'firebase/firebase-firestore'

const store = firebaseStore.firestore();

export { store }
